import { getHeroBanner } from "./hero-banner";

export const stopVideo = (videoElement: HTMLVideoElement | null) => {
  if (!videoElement) return;

  videoElement.pause();

  const heroBanner = getHeroBanner();

  if (heroBanner) {
    heroBanner.play();
  }
};
